{
  "eyebrow": "Bekreft abonnementet",
  "title": "Se gjennom og konfigurer.",
  "sub": "Du kan endre faktureringssyklus eller abonnement når som helst fra administratorpanelet.",
  "yourPlan": "Ditt abonnement",
  "changePlan": "Endre abonnement",
  "billing": "Faktureringssyklus",
  "billingMonthLabel": "Betal månedlig",
  "billingMonthDesc": "Fleksibelt. Avslutt når som helst.",
  "billingYearLabel": "Betal årlig",
  "billingYearDesc": "15% rabatt. Faktureres én gang i året.",
  "addons": "Tillegg",
  "addon": {
    "ssec": "Trygd (check-in/out@work)",
    "ssecDesc": "Bare Belgia — automatisk Dimona-melding.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live-GPS for firmakjøretøy. +4,80 €/kjøretøy/måned.",
    "vehicles": "Kjøretøy"
  },
  "users": {
    "title": "Hvor mange brukere trenger du?",
    "help": "Hver person som bruker Done-it, teller som én bruker, inkludert administratorer og ansatte.",
    "active": "brukere"
  },
  "estimate": "Estimerte månedlige kostnader",
  "estimateNote": "Eks. mva. Du betaler for antallet brukere du angir her, og kan endre det senere.",
  "estimateUnavailable": "Priskatalog ikke tilgjengelig. Prøv igjen for å laste de nyeste prisene."
}
